import Vue from 'vue';

import BcRetailLogo from '../components/BcRetailLogo.vue';
import AnimationLogoWrapper from '../components/AnimationLogoWrapper.vue';
import GoogleMap from '../components/GoogleMap.vue';

Vue.component('bc-retail-logo', BcRetailLogo)
Vue.component('animation-logo-wrapper', AnimationLogoWrapper)
Vue.component('google-map', GoogleMap)
